'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type * as React from 'react';
import { getQueryClient } from './getQueryClient';
export default function APIProviders({
  children
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const queryClient = getQueryClient();
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="APIProviders" data-sentry-source-file="APIProvider.tsx">
      {children}
      <ReactQueryDevtools data-sentry-element="ReactQueryDevtools" data-sentry-source-file="APIProvider.tsx" />
    </QueryClientProvider>;
}